<template>
	<v-dialog
		v-model="visible"
		class="users-list-dialog"
		max-width="500"
		scrollable
	>
		<template #activator="{ on, attrs }">
			<slot name="button" v-bind="{ on, attrs }" />
		</template>

		<v-card class="user-list" min-height="300" max-height="600">
			<v-list-item class="search" three-line>
				<v-text-field v-model="search" class="search-input" label="Find user">
					<v-icon slot="prepend" class="mt-1" color="grey lighten-1" small>
						fa-search
					</v-icon>
					<span slot="append" class="subtitle-2">
						{{ filteredUsers.length }} Results
					</span>
				</v-text-field>
			</v-list-item>

			<v-card-text>
				<v-list-item
					v-for="user in filteredUsers"
					:key="user.guid"
					:to="userPage(user)"
				>
					<v-list-item-title>
						{{ user.displayName || user.email }}
					</v-list-item-title>
				</v-list-item>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<style lang="scss" scoped>
.search {
	max-height: 92px;
}
</style>

<script>
import _ from "lodash";

export default {
	props: {
		users: {
			type: Array,
			required: true,
		},
		userType: {
			type: String,
			required: true,
		},
	},

	data: () => ({
		visible: false,
		search: "",
	}),

	computed: {
		communityId() {
			return this.$route.params.communityId;
		},

		filteredUsers() {
			return _.isEmpty(this.search)
				? this.users
				: _.filter(this.users, user => user.filter(this.search));
		},
	},

	watch: {
		visible(val) {
			// Clear search text
			if (!val) {
				this.search = "";
			}
		},
	},

	methods: {
		userPage(user) {
			return {
				name: "Live User",
				params: { userId: user.guid },
			};
		},
	},
};
</script>
